import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import { createConversation, getConversation, getConversationsByReference, submitMessage } from 'actions/conversation';
import ConversationMessages from 'containers/Conversation/Display/ConversationMessages';
import MessageForm from 'containers/Conversation/Form/MessageForm';
import Modal from 'containers/Modals/Modal';
import { Spinner } from 'UI';

var Message = /*#__PURE__*/function (_Component) {
  _inherits(Message, _Component);

  var _super = _createSuper(Message);

  /* Class setup */
  function Message(props) {
    var _this;

    _classCallCheck(this, Message);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      // Get conversations
      if (_this.props.assignment != null) {
        var assignment = _this.props.assignment;

        _this.props.getConversationsByReference(assignment.id, 'ASSIGNMENT').then(function () {
          _this.setState({
            loading: false
          });
        });
      }

      if (_this.props.plan != null) {
        var plan = _this.props.plan;

        _this.props.getConversationsByReference(plan.id, 'PLAN').then(function () {
          _this.setState({
            loading: false
          });
        });
      }

      if (_this.props.meetingInstance != null) {
        var meetingInstance = _this.props.meetingInstance;

        _this.props.getConversationsByReference(meetingInstance.id, 'MEETING_INSTANCE').then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.activeUser == null) {
        return false;
      }

      if (nextProps.activeUser != _this.props.activeUser) {
        var user = nextProps.activeUser;

        if (user.id == null) {
          user.id = user.userId;
        }

        var conversation = _this.getConversationForUser(user);

        if (conversation != null && conversation.id != 0) {
          _this.setState({
            loading: true
          });

          _this.props.getConversation(conversation.id).then(function () {
            _this.setState({
              loading: false
            });
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getCreatorId", function () {
      var creator = null;

      if (_this.props.assignment != null) {
        if (_this.props.assignment.id == parseInt(_this.props.assignment.id, 10)) {
          creator = _this.props.assignment.creator;
        } else {
          creator = _this.props.assignment.createdBy.user.id;
        }
      }

      if (_this.props.plan != null) {
        creator = _this.props.plan.creator;
      }

      if (_this.props.meetingInstance != null) {
        creator = _this.props.meetingInstance.creator;
      }

      return creator;
    });

    _defineProperty(_assertThisInitialized(_this), "buildReference", function () {
      var references = [];
      var reference = {};

      if (_this.props.assignment != null) {
        reference.referenceId = _this.props.assignment.id;
        reference.referenceType = 'ASSIGNMENT';
      }

      if (_this.props.plan != null) {
        reference.referenceId = _this.props.plan.id;
        reference.referenceType = 'PLAN';
      }

      if (_this.props.meetingInstance != null) {
        reference.referenceId = _this.props.meetingInstance.id;
        reference.referenceType = 'MEETING_INSTANCE';
      }

      if (_this.props.studentId != null && _this.props.activeUser.userType == "GUARDIAN") {
        var studentReference = {};
        studentReference.referenceId = _this.props.studentId;
        studentReference.referenceType = 'STUDENT';
        references.push(studentReference);
      }

      references.push(reference);
      return references;
    });

    _defineProperty(_assertThisInitialized(_this), "buildMemberships", function (user) {
      var memberships = [];
      memberships.push({
        membershipID: user.id,
        membershipType: user.userType == "GUARDIAN" ? 'GUARDIAN' : 'USER',
        permission: 'W'
      });
      memberships.push({
        membershipID: _this.props.user.id,
        membershipType: 'USER',
        permission: 'O',
        user: _this.props.user
      });
      return memberships;
    });

    _defineProperty(_assertThisInitialized(_this), "getConversationForUser", function (user) {
      var conversations = _this.props.conversations;

      if (conversations != null) {
        var found = conversations.find(function (conversation) {
          var userType = 'USER';

          if (user.userType == "GUARDIAN") {
            userType = 'GUARDIAN';
          }

          var membership = conversation.memberships.find(function (member) {
            return member.membershipType == userType && member.membershipID == user.id;
          });
          return membership != null;
        });
        return found;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "getMembership", function (conversation, userid) {
      var membership = conversation.memberships.find(function (member) {
        return member.membershipType == 'USER' && member.membershipID == userid;
      });

      if (membership != null) {
        return membership;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "onCreate", function (values, student) {
      return new Promise(function (resolve) {
        values.creator = _this.props.user.id;
        values.senderId = values.creator;
        values.senderType = 'USER';
        delete values.conversationID;
        var conversation = {
          messages: [values],
          memberships: _this.buildMemberships(student),
          relationships: _this.buildReference(),
          title: '',
          status: 'ACTIVE'
        };

        _this.props.createConversation(conversation).then(function () {
          _this.props.getConversation(_this.props["new"]);

          _this.componentDidMount();

          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submitMessage", function (values) {
      return new Promise(function (resolve) {
        var user = _this.props.user;
        values.creator = user.id;
        values.senderId = values.creator;
        values.senderType = 'USER';

        _this.props.submitMessage(values).then(function () {
          _this.setState({});

          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onModalClose", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderConversation", function () {
      var conversation = null;
      var created = true;
      var user = _this.props.activeUser;
      var trigger = _this.props.activeUser.firstName + ' ' + _this.props.activeUser.lastName;
      var disabled = false;

      if (user.id == null) {
        user.id = user.userId;
      }

      if (user != null) {
        conversation = _this.getConversationForUser(user);

        if (conversation != null && conversation.status.toUpperCase() == 'ARCHIVED') {
          disabled = true;
        }
      }

      if (conversation != null && conversation.status.toUpperCase() == 'ARCHIVED') {
        disabled = true;
      }

      if (conversation == null) {
        trigger = _this.props.translate('send-a-message');
        created = false;
        conversation = {
          id: 0
        };
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "conversation conversation--wrapper",
        style: {
          boxShadow: 'none',
          borderRadius: 0,
          height: '70vh'
        }
      }, created ? /*#__PURE__*/React.createElement(ConversationMessages, {
        conversation: _this.props.active
      }) : /*#__PURE__*/React.createElement("div", {
        className: "conversation-begin"
      }), created ? /*#__PURE__*/React.createElement(MessageForm, {
        conversation: conversation,
        onSubmit: _this.submitMessage,
        disabled: disabled
      }) : /*#__PURE__*/React.createElement(MessageForm, {
        conversation: null,
        onSubmit: function onSubmit(values) {
          return _this.onCreate(values, user);
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      if (_this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      return _this.renderConversation();
    });

    _this.state = {
      loading: true,
      open: ''
    };
    return _this;
  }
  /* Lifecycle methods */


  _createClass(Message, [{
    key: "render",
    value: function render() {
      if (this.props.activeUser == null) {
        return null;
      }

      var title = null;

      if (this.props.plan != null) {
        title = this.props.activeUser.firstname + ' ' + this.props.activeUser.lastname;
      } else {
        title = this.props.activeUser.firstName + ' ' + this.props.activeUser.lastName;
      }

      return /*#__PURE__*/React.createElement(Modal, {
        type: "small",
        overridePrompt: true,
        onClose: this.onModalClose,
        isOpen: true,
        title: title
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-assignment-message"
      }, this.renderContent()));
    }
  }]);

  return Message;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    conversations: state.Conversation.referenceConversations,
    active: state.Conversation.conversation,
    "new": state.Conversation["new"]
  };
}

export default connect(mapStateToProps, {
  getConversationsByReference: getConversationsByReference,
  createConversation: createConversation,
  submitMessage: submitMessage,
  getConversation: getConversation
})(Message);